import { useState } from 'react'
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import WebsiteJson from '../../Assets/JSON/MV.json'
import { IMAGE_BASE_PATH_COMMON } from '../../Config/Config'

const Infrastructure = () => {
  const infrastructure_data = WebsiteJson.Infrastructure
  const [openDialog, setOpenDialog] = useState(false)
  const [selectedItem, setSelectedItem] = useState('')
  const theme = useTheme()

  // Responsive breakpoints
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))
  const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'))

  const getCols = () => {
    if (isXs) return 1
    if (isSm) return 2
    if (isMd) return 3
    return 4 // For large screens
  }

  const handleOpenDialog = (item) => {
    setSelectedItem(item)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <section className="container py-4">
        <Typography variant="h4" align="center" className="py-2" gutterBottom>
          Infrastructure of our College
        </Typography>

        <ImageList
          sx={{
            overflowY: 'auto',
          }}
          cols={getCols()}
          gap={16}
        >
          {infrastructure_data?.map((item, index) => (
            <ImageListItem
              key={index}
              onClick={() => handleOpenDialog(item)}
              sx={{ cursor: 'pointer' }}
            >
              <img
                src={item.ImageURL}
                alt={item.Title}
                loading="lazy"
                placeholder="blur"
                style={{
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
                onError={(e) => {
                  e.target.src =
                    IMAGE_BASE_PATH_COMMON +
                    'Placeholders/Placeholder_Image.jpg'
                }}
              />
              <ImageListItemBar title={item.Title} />
            </ImageListItem>
          ))}
        </ImageList>

        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{selectedItem?.Title || ''}</DialogTitle>
          <DialogContent>
            <img
              src={selectedItem?.ImageURL}
              alt={selectedItem?.Title}
              loading="lazy"
              placeholder="blur"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '60vh',
                objectFit: 'contain',
                borderRadius: '8px',
              }}
              onError={(e) => {
                e.target.src =
                  IMAGE_BASE_PATH_COMMON + 'Placeholders/Placeholder_Image.jpg'
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Close</Button>
          </DialogActions>
        </Dialog>
      </section>
    </>
  )
}

export default Infrastructure
